import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'
import PropTypes from 'prop-types'

import { OnTrack, Warning } from '../../assets/icons'
import SVGWrapper from '../SVGWrapper'

const Pill = styled.div`
  display: inline-flex;
  align-items: center;
  column-gap: 5px;
  padding: ${p => (p.transparent ? '5px 0' : '5px 14px')};
  border-radius: 134px;
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 14px;
  background-color: ${p =>
    p.transparent
      ? 'transparent'
      : p.isOnTrack
        ? p.theme.onTrackRowBgColor
        : p.theme.notOnTrackRowBgColor};
  color: ${p => p.theme.lightestGray};
  cursor: default;

  /* Doubled selector outweighs SVGWrapper's hardcoded pointer cursor
     so the icon inherits the pill's. */
  && * {
    cursor: inherit;
  }
`

function StatusPill({ isOnTrack, transparent = false, className }) {
  const theme = useTheme()
  return (
    <Pill isOnTrack={isOnTrack} transparent={transparent} className={className} role='status'>
      {isOnTrack ? 'On-track' : 'Off-track'}
      <SVGWrapper
        svg={isOnTrack ? OnTrack : Warning}
        fill={theme.lightestGray}
        size='mediumLarge'
      />
    </Pill>
  )
}

StatusPill.propTypes = {
  isOnTrack: PropTypes.bool,
  /** Uses a transparent background with no horizontal padding. */
  transparent: PropTypes.bool,
  className: PropTypes.string,
}

export default StatusPill
